import React, { useEffect, useState } from "react";
import { Skeleton} from "antd";
import { calculateDateRangeFromDate } from '../../../../../../../Utils/DateConverstion';
import { APIConstants } from '../../../../../../../Common/APIConstants';
import { useStoreUpdaterWithAPI } from '../../../../../../../Hooks/UseStoreUpdaterWithApi';
import TempMeters from "./TempMeters";
import { useSelector } from "react-redux";



const TempConvertorStatus = () => {
    const {loading, makeRequest } = useStoreUpdaterWithAPI();
    const [treeChartInput, setTreeChartInput] = useState("");
    const [meterData, setMeterData] = useState([]);
    const mode = useSelector((state) => state.darkMode);
    const { isdarkMode } = mode;
    console.log(isdarkMode)


    const fetchConvertorStatus = (input) => {
        makeRequest({
          type: APIConstants.GET,
          url: `${APIConstants.GET_CONVERTER_STATUS_TEMPERATURE}?FromDate=${input.FromDate}&ToDate=${input.ToDate}`,
        }).then((res) => {
          setMeterData(res);
          console.log(res);
        });
      };
    
      useEffect(() => {
        if (treeChartInput) { 
          fetchConvertorStatus(treeChartInput);
        }
      }, [treeChartInput]);

      const setTreeChartInputString = () => { 
        // try {
    
        const currentDate = new Date();
        const { from, to } = calculateDateRangeFromDate(currentDate, 5, 1);
        const treeChartInputData = {
          FromDate: from,
          ToDate: to,
        };
        console.log(treeChartInputData);
    
        const finalInput = treeChartInputData;
        setTreeChartInput(finalInput);
    
      };
    
      useEffect(() => {
        setTreeChartInputString();
      }, []);

  return (
    <div>
       {
       
    <p className={` pb-2 text-xl ml-3 dark ${isdarkMode ? 'darkfont' : 'whitemode'} `}>CONVERTER STATUS</p>
    }
    <div className="flex justify-center">
    
      {loading  && ( 
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
      </> 
      )}
      {
        //   isError && (
        // <div className="flex flex-col">
        //   <img className="w-[150px] h-[80px] "  />
        //   <p className="text-sm text-red-500 text-center">Server error</p>
        //   <p className="text-center">Please reload the page</p>
        // </div>
        //   )
      }
    </div>
   
    {meterData && (
      <div className="flex flex-wrap gap-4">
        {meterData.map((item, index) => (
          <TempMeters key={index} item={item} />
        ))}
      </div>
    )}
  </div>
  )
}

export default TempConvertorStatus
